import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

const TrustIndicators = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const stats = [
    { number: "35+", label: "YILLIK TECRüBE", testId: "stat-experience" },
    { number: "10+", label: "TAMAMLANAN PROJE", testId: "stat-projects" },
    { number: "3", label: "HİZMET VERİLEN İLÇE", testId: "stat-districts" },
    { number: "200+", label: "MUTLU AİLE", testId: "stat-families" },
  ];

  return (
    <section
      className="py-24 bg-[#111111]"
      ref={ref}
      data-testid="trust-indicators-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center"
              data-testid={stat.testId}
            >
              <div className="text-gradient-gold font-light text-5xl md:text-6xl mb-3">
                {stat.number}
              </div>
              <div className="text-[#86868B] text-xs tracking-[0.2em] uppercase">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustIndicators;
